import columns from '../../../../../react-table/helpers/columns';
import { sumTotal } from '../../../../../react-table/helpers/rowTotals';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

let replacedDate;
export function getNavigationOptions(rowInfo) {
  if (rowInfo.original) {
    const date = rowInfo.original.handover.registrationDate;
    replacedDate = date.toString().replace('/', ' ');
  }
  const currentDatetime = new Date(replacedDate);
  const formattedDate = `${currentDatetime.getFullYear()}-${currentDatetime.getMonth() + 1}-${currentDatetime.getDate()}`;
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.OPERATIONAL_ANALYSIS.id,
    mainReportId: ReportDefinitions.OPERATIONAL_ANALYSIS_DAILY.id,
    requestParams: {
      date: true,
      destinationExchangeOffices: [],
      direction: ReportDefinitions.OPERATIONAL_ANALYSIS.reportDirections[0],
      period: {
        from: formattedDate,
        to: formattedDate,
      },
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    DateColumn,
    NonZeroNumberColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: 'Handover',
      columns: [
        new DateColumn('Registration date', 'handover.registrationDate').withTotalHeader('Total'),
        new NonZeroNumberColumn('Count', 'handover.tCount').withTotalHeader(sumTotal),
      ],
    },
    {
      Header: 'MRD labels',
      columns: [
        new NonZeroNumberColumn('Count', 'mrdLabels.count').withTotalHeader(sumTotal),
      ],
    },
    {
      Header: 'MRD labels scanned by post',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('Total', 'mrdLabelsScannedByPost.total').withTotalHeader(sumTotal), getNavigationOptions),
        new NonZeroNumberColumn('Same date', 'mrdLabelsScannedByPost.sameDate').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Later date', 'mrdLabelsScannedByPost.laterDate').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('With denested receptacles', 'mrdLabelsScannedByPost.withDenestedReceptacles').withTotalHeader(sumTotal),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NonZeroNumberColumn('Denested', 'receptacles.denested').withTotalHeader(sumTotal),
      ],
    },
  ];
};
